import { Text } from "../../ui/text";

type Props = {
  elapsedMs: number;
  className?: string;
};

/**
 * Fills the dead zone between "just started" and the 90s stall notice, so the
 * user can tell "normal" from "stuck" long before the watchdog would ever say so.
 */
const ElapsedHint = ({ elapsedMs, className }: Props) => {
  if (elapsedMs > 20_000) {
    return (
      <Text className={`${className} text-2xs text-warning-600`}>
        Llevamos {Math.floor(elapsedMs / 1000)}s…
      </Text>
    );
  }

  if (elapsedMs >= 8_000) {
    return (
      <Text className={`${className} text-2xs text-typography-400`}>
        Esto puede tardar unos segundos
      </Text>
    );
  }

  return null;
};

export default ElapsedHint;
